import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import { selectCurrent as selectUserCurrent } from "../../redux/user/selectors";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../hooks/hooks";
import { user } from "../../redux/user/actions";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import useWindowDimensions from '../../hooks/useWindowsDimensions';
import { useNavigate } from "react-router-dom";
const slider1 = require('./../../assets/img/slider1.png')
const slider2 = require('./../../assets/img/slider2.png')
import { useForm } from "react-hook-form";
import AccountSettings from "../../components/oneuser/AccountSettings";



const OneuserHelpCenter = () => {
	const navigate = useNavigate()
	const dispatch = useAppDispatch();
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
	const { height, width } = useWindowDimensions();
	const { theme } = useSelector(selectCurrent)
	const { isEditPersonalInfo } = useSelector(selectUserCurrent)
	const [color, setColor] = useState('universal')
	const [primary, setPrimary] = useState('#FFB934FF')
	const [secondary, setSecondary] = useState('#FFB934FF')
	const [menu, setMenu] = useState(false)
	const [open, setOpen] = useState([true, true, true, true, true])
	const [banner, setBanner] = useState([{ id: 1, image: slider1 }, { id: 2, image: slider2 }]);
	const [index, setIndex] = useState(0);
	const [sliderData, setSliderData] = useState([{ id: 1, src: slider1 }, { id: 2, src: slider2 }])
	const [steps, setSteps] = useState({})

	const AnyReactComponent = ({ text }: any) => <div>{text}</div>;

	useEffect(() => {
		const lastIndex = banner.length - 1;
		if (index < 0) {
			setIndex(lastIndex);
		}
		if (index > lastIndex) {
			setIndex(0);
		}
	}, [index, banner]);

	useEffect(() => {
		let slider = setInterval(() => {
			setIndex(index + 1);
		}, 3000);
		return () => clearInterval(slider);
	}, [index]);

	useEffect(() => {
		setColor(theme)
		if (theme == 'darkmode') {
			setPrimary('#f5e93cac')
			setSecondary('#ffffff')
		}
		else if (theme == 'lightmode') {
			setPrimary('#ffffffa2')
			setSecondary('#000000a2')
		}
		else if (theme == 'universal') {
			setPrimary('#233C64')
			setSecondary('#ffffff')
		}
		else if (theme == 'luxury') {
			setPrimary('#bd238c')
			setSecondary('#ffffff')
		}
		else if (theme == 'harmony') {
			setPrimary('#000000a2')
			setSecondary('#000000a2')
		}
		else if (theme == 'warmth') {
			setPrimary('#000000a2')
		}
		// const data = document.getElementById("layer") as HTMLInputElement;
		// data.setAttribute("fill", "#603812")
		// data.setAttribute("stroke", "#603812")
	}, [theme]);

	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}

	const handleSave = () => {
		dispatch(user.set({ isEditPersonalInfo: false }))
	}

	const handleClose = () => {
	}

	return (
		<>
			{width && width < 720 ? <div className={`max-h-screen py-5`}>
				<header className={`fixed w-screen z-10  flex items-center justify-between px-1 py-5  top-0 h-auto primary-${color}`}>
					<div className="flex flex-col w-full justify-start items-center space-y-3 ">
						<div className="flex w-full justify-center items-center py-1 px-6 ">
							<div className="flex justify-items-start w-1/3" onClick={() => navigate(-1)} >
								<svg version="1.1" id="Capa_1" className="h-8 w-8 " fill="currentColor" viewBox="0 0 26.676 26.676">
									<path d="M26.105,21.891c-0.229,0-0.439-0.131-0.529-0.346l0,0c-0.066-0.156-1.716-3.857-7.885-4.59
		c-1.285-0.156-2.824-0.236-4.693-0.25v4.613c0,0.213-0.115,0.406-0.304,0.508c-0.188,0.098-0.413,0.084-0.588-0.033L0.254,13.815
		C0.094,13.708,0,13.528,0,13.339c0-0.191,0.094-0.365,0.254-0.477l11.857-7.979c0.175-0.121,0.398-0.129,0.588-0.029
		c0.19,0.102,0.303,0.295,0.303,0.502v4.293c2.578,0.336,13.674,2.33,13.674,11.674c0,0.271-0.191,0.508-0.459,0.562
		C26.18,21.891,26.141,21.891,26.105,21.891z"/>
								</svg>
							</div>
							<div className="flex w-2/3 flex-row justify-end items-center space-x-3">
								<div className=" w-auto item-center p-1"
									onClick={() => navigate(-1)} >
									<img src={require('./../../assets/img/avathar.png')} width="48" height="48" />
								</div>
								<div className="text-xl" >
									Raja Kuttralam
								</div>
							</div>
						</div>
					</div>
				</header>
				<div className="z-20 h-full py-10 pb-24 overflow-y-auto mt-12">
					<form onSubmit={handleSubmit(handleSave)} >
						<div className="w-full  rounded-lg  flex flex-col  text-black p-5">
							<div className="flex flex-col items-start justify-between w-full space-y-3 border-b p-2 border-blue-500">
								<div className="flex w-full flex-col items-start justify-between text-xl" >
									Ticket Details
								</div>




							</div>
							<div className="flex flex-col items-start justify-between w-full space-y-3 border-b p-2 border-blue-500">
								<div className="flex w-full flex-col items-start justify-between text-xs" >
									Date : 17-Apr-2024
								</div>
								<div className="flex w-full flex-col items-start justify-between text-xs" >
									Ticke Ref : #23879900-02
								</div>
								<div className="flex w-full flex-row items-start justify-start text-xs" >
									Status : <span className="bg-red-300 w-max rounded">In Progress</span>
								</div>
							</div>
							<div className="flex flex-col items-start justify-between w-full space-y-3 border-b p-2 border-blue-500">
								<div className="flex w-full flex-col items-start justify-between text-xs" >
									Date : 11-Mar-2024
								</div>
								<div className="flex w-full flex-col items-start justify-between text-xs" >
									Ticke Ref : #111-79900-02
								</div>
								<div className="flex w-full  flex-row items-start justify-start text-xs" >
									Status : <span className="bg-blue-300 w-max rounded">Closed</span>
								</div>
							</div>
							<div className="w-full flex text-center mt-6">
								<input type="submit"
									className="bg-red-500 text-white text-xl p-2 w-full"
									value='Write Us : support@digiit.co'
								/>
							</div>
							<div className="w-full flex text-center mt-6">
								<input type="submit"
									className="bg-red-500 text-white text-xl p-2 w-full"
									value='Call Center : 1011-22344-456'
								/>
							</div>
						</div>
					</form>
				</div>
				<footer className={`fixed  bottom-0 z-10 w-screen flex items-center justify-between h-20   primary-${color}`}>
					<div className="flex w-full justify-around items-center">
						<ul className="flex justify-around items-center w-full">
							<li onClick={() => navigate('/oneuser/profile')}
								className=" flex flex-col items-center justify-center space-y-1">
								<svg fill="#ffffff" className="w-8 h-8" viewBox="0 0 24 24" data-name="Layer 1" id="Layer_1">
									<title />
									<path d="M22,11V7.83L12,2.06,2,7.83V11H4v8H2v2H22V19H20V11ZM4,9l8-4.62L20,9H4ZM6,19V11H8v8Zm4,0V11h4v8Zm8,0H16V11h2Z" />
								</svg>
								<a className=" hover:text-[#FFB934] uppercase text-xs">
									Account
								</a>
							</li>
							<li
								onClick={() => navigate('/oneuser/address')}
								className=" flex flex-col items-center justify-center space-y-1">
								<svg className="w-8 h-8" fill="#ffffff" viewBox="0 0 24 24" ><path d="M4 4H3v1h2V2h1v20H5v-1H4v2h18V1H4zm3-2h14v20H7zM5 20H3v-1h1v-1h1zm0-6H3v-1h1v-1h1zm0-6H3V7h1V6h1zm0 3H3v-1h1V9h1zm0 6H3v-1h1v-1h1zm10.5-5h-3A3.504 3.504 0 0 0 9 15.5V18h10v-2.5a3.504 3.504 0 0 0-3.5-3.5zm2.5 5h-8v-1.5a2.503 2.503 0 0 1 2.5-2.5h3a2.503 2.503 0 0 1 2.5 2.5zm-4-6a3 3 0 1 0-3-3 3.003 3.003 0 0 0 3 3zm0-5a2 2 0 1 1-2 2 2.002 2.002 0 0 1 2-2z" /><path fill="none" d="M0 0h24v24H0z" /></svg>								<a className=" hover:text-[#FFB934] uppercase text-xs" href="#">
									Address
								</a>
							</li>
							<li className=" flex flex-col items-center justify-center space-y-1">
								<svg className="w-8 h-8" fill="#ffffff" viewBox="0 0 256 256"><path d="M201.89,54.66A103.43,103.43,0,0,0,128.79,24H128A104,104,0,0,0,24,128v56a24,24,0,0,0,24,24H64a24,24,0,0,0,24-24V144a24,24,0,0,0-24-24H40.36A88.12,88.12,0,0,1,190.54,65.93,87.39,87.39,0,0,1,215.65,120H192a24,24,0,0,0-24,24v40a24,24,0,0,0,24,24h24a24,24,0,0,1-24,24H136a8,8,0,0,0,0,16h56a40,40,0,0,0,40-40V128A103.41,103.41,0,0,0,201.89,54.66ZM64,136a8,8,0,0,1,8,8v40a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V136Zm128,56a8,8,0,0,1-8-8V144a8,8,0,0,1,8-8h24v56Z"></path></svg>
								<a className=" hover:text-[#FFB934] uppercase text-xs" href="#">
									Help Center
								</a>
							</li>
							<li className=" flex flex-col items-center justify-center space-y-1" >
								<svg fill="#ffffff" className="h-8 w-8" version="1.1" id="Capa_1" viewBox="0 0 384.971 384.971">
									<path d="M180.455,360.91H24.061V24.061h156.394c6.641,0,12.03-5.39,12.03-12.03s-5.39-12.03-12.03-12.03H12.03
			C5.39,0.001,0,5.39,0,12.031V372.94c0,6.641,5.39,12.03,12.03,12.03h168.424c6.641,0,12.03-5.39,12.03-12.03
			C192.485,366.299,187.095,360.91,180.455,360.91z"/>
									<path d="M381.481,184.088l-83.009-84.2c-4.704-4.752-12.319-4.74-17.011,0c-4.704,4.74-4.704,12.439,0,17.179l62.558,63.46H96.279
			c-6.641,0-12.03,5.438-12.03,12.151c0,6.713,5.39,12.151,12.03,12.151h247.74l-62.558,63.46c-4.704,4.752-4.704,12.439,0,17.179
			c4.704,4.752,12.319,4.752,17.011,0l82.997-84.2C386.113,196.588,386.161,188.756,381.481,184.088z"/>
								</svg>								<a className=" hover:text-[#FFB934] uppercase text-xs" href="#">Logout</a>
							</li>
						</ul>
					</div>
				</footer >
			</div > :
				<div className="h-screen flex flex-col justify-between items-stretch bg-white">
					
					<div className="flex flex-row">
					<AccountSettings />
						<div className="w-3/4  justity-center items-center">
							<form onSubmit={handleSubmit(handleSave)} >
								<div className="w-full  rounded-lg  flex flex-col  text-black p-5">
									<div className="flex flex-col items-start justify-between w-full space-y-3 border-b p-2 border-blue-500">
										<div className="flex w-full flex-col items-start justify-between text-xl" >
											Ticket Details
										</div>




									</div>
									<div className="flex flex-col items-start justify-between w-full space-y-3 border-b p-2 border-blue-500">
										<div className="flex w-full flex-col items-start justify-between text-xs" >
											Date : 17-Apr-2024
										</div>
										<div className="flex w-full flex-col items-start justify-between text-xs" >
											Ticke Ref : #23879900-02
										</div>
										<div className="flex w-full flex-row items-start justify-start text-xs" >
											Status : <span className="bg-red-300 w-max rounded">In Progress</span>
										</div>
									</div>
									<div className="flex flex-col items-start justify-between w-full space-y-3 border-b p-2 border-blue-500">
										<div className="flex w-full flex-col items-start justify-between text-xs" >
											Date : 11-Mar-2024
										</div>
										<div className="flex w-full flex-col items-start justify-between text-xs" >
											Ticke Ref : #111-79900-02
										</div>
										<div className="flex w-full  flex-row items-start justify-start text-xs" >
											Status : <span className="bg-blue-300 w-max rounded">Closed</span>
										</div>
									</div>
									<div className="w-full flex text-center mt-6">
										<input type="submit"
											className="bg-red-500 text-white text-xl p-2 w-full"
											value='Write Us : support@digiit.co'
										/>
									</div>
									<div className="w-full flex text-center mt-6">
										<input type="submit"
											className="bg-red-500 text-white text-xl p-2 w-full"
											value='Call Center : 1011-22344-456'
										/>
									</div>
								</div>
							</form>
						</div>
					</div>
					
				</div>}
		</>
	)
}

export default OneuserHelpCenter

